export const getTokenFromCookie = () => {
  const cookies = document.cookie.split(';').map((cookie) => cookie.trim())
  for (const cookie of cookies) {
    const [name, value] = cookie.split('=')
    if (name === 'token') {
      return decodeURIComponent(value)
    }
  }

  return null
}

export const removeTokenFromCookie = () => {
  document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
}

export const setTokenInCookie = (token, expiresInSeconds) => {
  const expirationTime = new Date(Date.now() + expiresInSeconds * 1000)
  document.cookie = `token=${encodeURIComponent(token)}; expires=${expirationTime.toUTCString()}; path=/`
}
